import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    // background-color: ${({ theme }) => theme.colors.background};
    background: url("/images/CCC_background.png");
    background-size: cover;
    min-height: 100vh;
    font-family: "Poppins", sans-serif;


    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
